var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowXlR = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "81px",
    viewBox: "0 0 43 81",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "arrow_xl_r")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.41545073,79.9984508 L41.7054507,41.7054508 C42.0796584,41.3287246 42.2914482,40.8204291 42.2954507,40.2894508 C42.2862672,39.76072 42.0751753,39.2555306 41.7054507,38.8774508 L3.41545073,0.58645081 C2.91027719,0.0809200002 2.17378011,-0.116702854 1.48339081,0.0680248636 C0.793001515,0.252752581 0.253606563,0.791766336 0.0683908112,1.48202486 C-0.11682494,2.17228339 0.080277188,2.90892 0.585450732,3.41445081 L37.4654507,40.2894508 L0.585450732,77.1704508 C-0.195479671,77.9519338 -0.195031845,79.21852 0.58645098,79.9994506 C1.3679338,80.7803811 2.63452006,80.7799335 3.41545073,79.9984508 L3.41545073,79.9984508 Z",
    id: "arrow_xl_r",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowXlR, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow_xl_r.76c4a1d2.svg";
export { ForwardRef as ReactComponent };